import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';

const PAYMENT_LEGALESE_CLASS = 'payment-brand-disclaimer';




class PaymentBrandLegalDisclaimer extends React.Component {
    render() {
        const { markup } = this.props;
        return (
            <div className={PAYMENT_LEGALESE_CLASS}>
                <small key={PAYMENT_LEGALESE_CLASS}>
                    <Markdown>{markup}</Markdown>
                </small>
            </div>
        );
    }
}


PaymentBrandLegalDisclaimer.propTypes = {
    markup: PropTypes.string.isRequired 
};

export default PaymentBrandLegalDisclaimer;
